// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2YDbQ","name":"ConsentHeader_name__3unNX","birthday":"ConsentHeader_birthday__16Xqb","skeleton":"ConsentHeader_skeleton__BdLS8"};